// import { asyncTimeOut, clone, requiredParam } from '@/service/util'
import * as sincBanco from '@/api/sincBanco'
import { getFilaProcessada } from '../../../api/sincBanco'

const prettyStatus = status => {
  const primeiraLetraMaiscula = string => string[0].toLocaleUpperCase() + string.slice(1)
  const separaPalavra = (string, separador = '_') => {
    let palavras = string.split(separador)
    return palavras.map(p => primeiraLetraMaiscula(p)).join(' ')
  }
  let retorno = {}
  if (status.label && status.name) {
    retorno = status
  } else if (status.name && !status.label) {
    retorno = { name: status.name, label: status.name }
  } else {
    retorno = { name: status, label: status }
  }

  retorno.label = separaPalavra(retorno.label)
  return retorno
}

const state = {
  modal: false,
  processando: false,
  pedidoId: 0,
  filas: []
}

const getters = {
  filas: state => {
    return state.filas
  }
}

const mutations = {
  SETMODAL (state, payload) {
    state.modal = payload
  },
  SETEXIBIRFILA (state) {
    state.processando = true
  },
  SETFILAS (state, payload) {
    state.filas = payload
  },
  SETLIMPAFILAS (state) {
    state.filas = []
  },
  SETESCONDERFILA (state) {
    state.processando = false
  },
  SETPEDIDOID (state, payload) {
    state.pedidoId = payload
  }
}

const actions = {
  abreModal ({ commit }, payload) {
    commit('SETMODAL', true)
  },
  fechaModal ({ commit }) {
    commit('SETMODAL', false)
  },
  setPedidoId ({ commit }, payload) {
    commit('SETPEDIDOID', Number(payload))
  },
  convertFilas ({ commit }, payload) {
    let filas = []
    if (!payload.length) return filas
    const mergeObj = (objOriginal, objMerge) => Object.assign({}, objOriginal, objMerge)
    const convertStatus = (status) => ({ status: prettyStatus(status) })
    if (Array.isArray(payload)) {
      filas = payload.map(p => mergeObj(p, convertStatus(p.status)))
    } else {
      filas = mergeObj(payload, convertStatus(payload.status))
    }
    return filas
  },
  limpaFilas ({ commit }) {
    commit('SETLIMPAFILAS')
  },
  async getFilas ({ commit, dispatch }, payload) {
    return dispatch('getFilasComSemLoad', { payload, load: true })
  },
  async getFilasSemLoad ({ commit, dispatch, state }, payload) {
    return dispatch('getFilasComSemLoad', { payload, load: false })
  },
  async getFilasComSemLoad ({ commit, dispatch, state }, param) {
    const pedidoId = Number(param.payload) || state.pedidoId

    let filasApi = []
    if (param.load) filasApi = await sincBanco.getFilas(pedidoId)
    else filasApi = await sincBanco.getFilasSemLoad(pedidoId)

    const instancia = filasApi.instancia
    const filasConvert = await dispatch('convertFilas', instancia)
    commit('SETFILAS', filasConvert)
    commit('SETPEDIDOID', pedidoId)
    dispatch('exibicaoFilas')
    return filasConvert
  },
  async iniciaProcesso ({ commit }, payload) {
    await sincBanco.iniciaProcesso(payload)
  },
  exibicaoFilas ({ commit, state }) {
    if (Array.isArray(state.filas) && state.filas.length) {
      commit('SETEXIBIRFILA')
    } else {
      commit('SETESCONDERFILA')
    }
  },
  esconderFilas ({ commit }) {
    commit('SETESCONDERFILA')
  },
  async reiniciaFila ({ commit, dispatch, state }, payload) {
    await sincBanco.reiniciaFila(payload)
    await dispatch('getFilas', payload.pedidoId)
  },
  async cancelaFila ({ commit, dispatch, state }, payload) {
    await sincBanco.cancelaFila(payload)
    await dispatch('getFilas', payload.pedidoId)
  },
  async cancelaTodasFilas ({ commit, dispatch, state }) {
    await sincBanco.cancelaTodasFilas(state.pedidoId)
    await dispatch('getFilas')
  },
  async getFilaProcessada ({ commit }, payload) {
    const result = await getFilaProcessada(payload)
    const instancia = result.instancia
    return instancia.concluido
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/sincBanco.js